import { InputHTMLAttributes, useEffect, useState } from "react";
import { trans } from "utils/helpers";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button } from "components/Button/Button";
import { Textbox } from "components/Textbox/Textbox";
import { ICON_TYPE } from "utils/constants";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

interface KeyWordProp extends InputHTMLAttributes<HTMLInputElement> {
  setKeyWords: (list) => void;
  label?: string;
  name: string;
  value?: any;
  mode?: any;
  withSystemKey?: any;
  keyWords?: any;
  required?: boolean;
  Change?: (e) => void;
  recordedData?: any;
  label2?:any
}
export const KeyWord = ({
  withSystemKey,
  setKeyWords,
  Change,
  label = "keywords",
  name,
  value,
  keyWords,
  mode,
  required,
  recordedData = [],
  label2
}: KeyWordProp) => {
  const [resetForm, setResetForm] = useState<any>(false);
  const [change, setChange] = useState<any>(false);
  const [selectedItem, setSelectedItem] = useState<any>(
    keyWords ? keyWords : []
  );

  function addOption(e) {
    e.stopPropagation();
    e.preventDefault();
    let event: any = document.getElementById(`KeyWordForm${name}`);
    if (event["Keyword"].value.length > 0) {
      if (withSystemKey) {
        setSelectedItem(
          selectedItem.concat([
            {
              name: event["Keyword"].value,
              SystemKey: event["SystemKey"].value,
            },
          ])
        );
        setKeyWords(
          selectedItem.concat([
            {
              name: event["Keyword"].value,
              SystemKey: event["SystemKey"].value,
            },
          ])
        );
      } else {
        setSelectedItem(selectedItem.concat([event["Keyword"].value]));
        setKeyWords(selectedItem.concat([event["Keyword"].value]));
      }
      setResetForm(true);
      setChange(false);
    }
  }
  function DelOption(e) {
    let list: any = [];
    selectedItem.forEach((item) => {
      if (item != e) {
        list.push(item);
      }
    });
    setSelectedItem(list);
    setKeyWords(list);
  }

  useEffect(() => {
    if (resetForm) {
      setResetForm(false);
    }
  }, [resetForm]);

  useEffect(() => {
    if (keyWords && recordedData) {
      setSelectedItem(keyWords);
      if (recordedData.length == selectedItem.length) {
        let flag = true;
        recordedData.forEach((element) => {
          if (!selectedItem.includes(element)) flag = false;
        });
        !flag
          ? Change && Change({ [name]: selectedItem })
          : Change && Change({ [name]: null });
      } else {
        Change && Change({ [name]: selectedItem });
      }
    }
  }, [keyWords]);
  return (
    <>
      <>
        {mode != "view" ? (
          <form
            id={`KeyWordForm${name}`}
            onSubmit={addOption}
            style={{
              display: "flex",
              alignItems: "center",
              flexDirection: "row",
              width: "100%",
            }}
          >
            <div style={{ width: "90%" }}>
              <input
                value={selectedItem.join(",")}
                name="KeyWords"
                className="d-none"
                onChange={(e) => {}}
              />
              <Textbox
                required={required}
                Change={setChange}
                textboxType="text"
                textboxName="Keyword"
                labelText={label}
                maxLength={900}
                resetForm={resetForm}
                mode={mode}
              />
            </div>
            {withSystemKey && (
              <div style={{ width: "90%" }}>
                <input
                  value={selectedItem.join(",")}
                  name="KeyWords"
                  className="d-none"
                  onChange={(e) => {}}
                />
                <Textbox
                  required={required}
                  Change={setChange}
                  textboxType="text"
                  textboxName="SystemKey"
                  labelText={label2?label2:"SystemKey"}
                  maxLength={900}
                  resetForm={resetForm}
                  mode={mode}
                />
              </div>
            )}
            <div
              style={{
                marginTop: label.length > 1 ? "4px" : "-7px",
                width: "10%",
              }}
            >
              <Button
                Icon={true}
                value={
                  <button onClick={addOption} className="checkButton">
                    {" "}
                    <FontAwesomeIcon icon={[ICON_TYPE, "check"]} size="2x" />
                  </button>
                }
                btnType="submit"
                onClick={addOption}
              />
            </div>
          </form>
        ) : (
          <Textbox
            textboxType="text"
            textboxName="Keyword"
            labelText={label}
            maxLength={900}
            defaultValue={selectedItem.join(",")}
            resetForm={resetForm}
            mode={mode}
          />
        )}
        {mode !== "view" && (
          <div className="group-person__selected-options-wrapper pt-0 ">
            {selectedItem.map(
              (item, index) =>
                (item.length > 0 || item?.name.length > 0) && (
                  <OverlayTrigger
                    placement="bottom"
                    delay={{ show: 300, hide: 0 }}
                    overlay={
                      <Tooltip
                        className="tooltip"
                        id={`button-tooltip-${"chalkboardg"}`}
                      >
                        {withSystemKey
                          ? item.name + ", " + item.SystemKey
                          : item}
                      </Tooltip>
                    }
                  >
                    <div
                      key={index}
                      className="group-person__selected-option form-control-custom"
                    >
                      {withSystemKey ? item.name + ", " + item.SystemKey : item}
                      <div
                        className="group-person__delete-selected-option"
                        onClick={() => DelOption(item)}
                      >
                        <FontAwesomeIcon icon={[ICON_TYPE, "times"]} />
                      </div>
                    </div>
                  </OverlayTrigger>
                )
            )}
          </div>
        )}
      </>
    </>
  );
};
